export default __webpack_public_path__ + "static/nanno_screen_2-c1f1ba51e53e72e42010837fe2141a74.svg";